<div class="text-field" [ngClass]="state()" [class.is-disabled]="disabled()">
  <label class="text-field-container">
    <ui-inline-svg *ngIf="icon() && iconPosition() !== 'right'" class="text-field-icon" [name]="icon()"></ui-inline-svg>
    @if (mask()) {
      <input class="text-field-input" [mask]="mask()" [prefix]="prefix()" [thousandSeparator]="thousandSeparator()" [decimalMarker]="decimalMarker()" [allowNegativeNumbers]="allowNegativeNumbers()" [outputTransformFn]="toStringValue" type="text" [placeholder]="placeholder()" [(ngModel)]="value" [name]="name()" [disabled]="disabled()" (blur)="blurred.emit(value())">
    } @else {
      <input class="text-field-input" type="text" [placeholder]="placeholder()" [(ngModel)]="value" [name]="name()" [disabled]="disabled()" (blur)="blurred.emit(value())">
    }
    <ui-inline-svg *ngIf="icon() && iconPosition() === 'right'" class="text-field-icon-action" [name]="icon()"></ui-inline-svg>
  </label>
  @if (alert() && state() !== fieldState.Default) {
    <div class="text-field-alert">
      <ui-inline-svg class="text-field-alert-icon" [name]="alertIcon()"></ui-inline-svg>
      <span class="text-field-alert-text">{{ alert() }}</span>
    </div>
  }
</div>
